import { useCallback } from 'react'
import { ListControlsRequest, ControlIds } from '@trustero/trustero-api-web/lib/model/control_pb'
import { ModelPromiseClient } from '@trustero/trustero-api-web/lib/model/model_grpc_web_pb'
import { GrpcResponse, NewGrpcResponse } from '../../hooks/types'
import { useGrpcRevalidateByMethod } from '../../useGrpcMutate'
import { useSwrImmutableGrpc } from '../../useSwrImmutableGrpc'
import { useNewModel } from '../../hooks/useNewModel'

export const useListControlIds = (
  request: ListControlsRequest = new ListControlsRequest(),
  ignoreAuditContext = false,
): GrpcResponse<ControlIds> => {
  const newModel = useNewModel()
  if (newModel) {
    request.setUseNewModel(newModel)
  }
  const { response } = useSwrImmutableGrpc(
    ModelPromiseClient.prototype.listControlIds,
    request,
    true,
    {
      ignoreAuditContext,
    },
  )
  return NewGrpcResponse(response)
}

export const useInvalidateListControlIdsCache = (): (() => Promise<void>) => {
  const mutateFunc = useGrpcRevalidateByMethod()

  return useCallback(async () => {
    await Promise.all([
      mutateFunc(ModelPromiseClient.prototype.listControlIds),
    ])
  }, [mutateFunc])
}
